import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNAnonymousReportRequest extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNAnonymousReportRequest';
    }

    /**
     * factory clone
     * @returns CNAnonymousReportRequest
     */

    public clone(): any {
        return new CNAnonymousReportRequest();
    }    
}
